import React from 'react';
import { WEATHER } from '../../data/mock';
import { CloudSunIcon, FlowerIcon } from '../icons';

/** Weather & pollen detail — opened from a result card or dashboard recommendation. */
export function WeatherModal() {
  return <div className="px-5 pb-10 pt-2" data-id="element-821">
      {/* header */}
      <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-sky-deep" data-id="element-822">{WEATHER.location}</p>
      <h2 className="font-display mt-1 text-[22px] font-semibold leading-tight text-ink" data-id="element-823">{WEATHER.day}</h2>

      {/* hero */}
      <div className="mt-4 flex items-center justify-between rounded-card bg-sky-soft p-5" data-id="element-824">
        <div data-id="element-825">
          <div className="font-display text-[56px] font-light leading-none text-sky-deep" data-id="element-826">{WEATHER.temp}°</div>
          <p className="mt-1 text-[14px] font-semibold text-sky-deep" data-id="element-827">{WEATHER.condition}</p>
        </div>
        <CloudSunIcon size={84} strokeWidth={1.2} className="dhp-float text-sky" data-id="element-828" />
      </div>

      {/* hourly strip */}
      <div className="no-scrollbar mt-3 flex gap-2 overflow-x-auto" data-id="element-829">
        {WEATHER.hours.map(h => <div key={h.t} className="flex shrink-0 flex-col items-center gap-1 rounded-2xl bg-linen px-4 py-3" data-id="element-830">
            <span className="text-[11px] font-bold text-ink-faint" data-id="element-831">{h.t}</span>
            <span className="font-display text-[16px] font-semibold text-ink" data-id="element-832">{h.temp}°</span>
          </div>)}
      </div>

      {/* pollen — the part that matters for an asthma companion */}
      <div className="mt-5 rounded-card border border-[#E0785633] bg-coral-soft p-4" data-id="element-833">
        <div className="flex items-center justify-between" data-id="element-834">
          <div className="flex items-center gap-2" data-id="element-835">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-coral text-cream" data-id="element-836">
              <FlowerIcon size={18} data-id="element-837" />
            </span>
            <h3 className="font-display text-[16px] font-semibold text-ink" data-id="element-838">Grass pollen</h3>
          </div>
          <span className="rounded-full bg-coral px-3 py-1 text-[12px] font-bold text-cream" data-id="element-839">{WEATHER.pollen.level}</span>
        </div>

        {/* meter */}
        <div className="mt-3 h-2.5 overflow-hidden rounded-full bg-cream" data-id="element-840">
          <div className="h-full rounded-full bg-coral" style={{
          width: `${WEATHER.pollen.pct}%`
        }} data-id="element-841" />
        </div>

        {/* guidance comes from the care plan — curated, not generated */}
        <p className="mt-3 text-[13px] leading-relaxed text-ink-soft" data-id="element-842">{WEATHER.pollen.note}</p>
      </div>

      {/* stats grid */}
      <div className="mt-3 grid grid-cols-2 gap-2.5" data-id="element-843">
        {WEATHER.stats.map(s => <div key={s.label} className="rounded-2xl bg-linen p-3.5" data-id="element-844">
            <p className="text-[11px] font-bold uppercase tracking-[0.12em] text-ink-faint" data-id="element-845">{s.label}</p>
            <p className="font-display mt-1 text-[18px] font-semibold text-ink" data-id="element-846">{s.value}</p>
          </div>)}
      </div>
    </div>;
}